import { qs, qsa, all } from '../helpers/querySelector';
import HeightGroup from '../classes/HeightGroup';
import Isotope from 'isotope-layout';
import * as basicScroll from 'basicscroll';
import * as Scroll from '../components/_scroll';

export default function() {
    let heightGroup = new HeightGroup('.js-match-case-study');
    heightGroup.watchElements();

    const container = qs('.js-case-study-container');
    const caseStudies = qsa('.js-case-study');
    const iso = new Isotope(container, {
        itemSelector: '.js-case-study',
        layoutMode: 'fitRows',
        percentPosition: true,
    });

    const parallax = basicScroll.create({
        elem: container,
        from: 'top-bottom',
        to: 'bottom-top',
        props: {
            '--ty': {
                from: '-100px',
                to: '100px',
                timing: 'cubicInOut',
            },
        },
    });
    parallax.start();

    const filterButtons = qsa('.js-filter-button');
    all(filterButtons, button => {
        button.addEventListener('click', e => {
            e.preventDefault();

            all(caseStudies, el => {
                el.classList.remove('-bump-up');
                el.classList.remove('-no-bump');
            });

            const key = button.getAttribute('href').substring(1);
            const filterKey = key ? `.js-category-${key}` : '*';
            iso.arrange({ filter: filterKey });

            all(filterButtons, button => {
                button.classList.remove('-active');
            });
            e.target.classList.add('-active');

            iso.getFilteredItemElements().forEach((el, key) => {
                if ((key % 3) - 1 === 0) el.classList.add('-bump-up');
                else el.classList.add('-no-bump');
            });

            parallax.update();
            Scroll.recalcBackgroundSections();
        });
    });

    iso.on('arrangeComplete', heightGroup.matchHeights());
}



// WEBPACK FOOTER //
// ./assets/js/components/_work.js